<template>
  <section class="content">
    <!-- Modal -->
    <div class="modal fade" id="confirmacaoModal" tabindex="-1" role="dialog" aria-labelledby="confirmacaoModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content panel-danger">
          <div class="modal-header panel-heading">
            <h4 class="modal-title" id="confirmacaoModalLabel">{{tituloModal}}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{mensagemModal}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-if="isTurno" @click="deletarTurno(turnoParaApagar)">Confirmar</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-else @click="deletarParada(paradaParaApagar)">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  
    <div>
      <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{messageAlert}}
    </b-alert>
    </div>
    <div class="row center-block" v-show="exibirListagem">
      <h2>Listagem</h2>
      <div class="col-md-12" >
        <div class="box">
          <div class="box-header">
            <h3 class="box-title" v-show="!exibirDetalharTurno">Listagem dos Turnos Cadastrados</h3>
            <h3 class="box-title" v-show="exibirDetalharTurno">Alterar Dados do Turno</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive" v-show="!exibirDetalharTurno" >
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th>Nome</th>
                  <th>Início</th>
                  <th>Término</th>
                  <th>Tempo Total</th>
                  <th>Tempo Paradas</th>
                  <th>Tempo Útil</th>
                  <th class="text-center">Ações</th>
                </tr>
                <tr v-for="turno in turnos" :key="turno.id">
                  <td>{{turno.nometurno}}</td>
                  <td>{{turno.horainicio}}</td>
                  <td>{{turno.horafim}}</td>
                  <td>{{turno.tempototal}}</td>
                  <td>{{turno.tempototalparada}}</td>
                  <td>{{turno.tempoutil}}</td>
                  <td>
                    <div class="text-center">
                      <a class="btn btn-sm" v-on:click="selecionarTurno(turno)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i> Editar / Detalhar</span></a> 
                      <a class="btn btn-sm" v-on:click="prepararDeletarTurno(turno)" data-toggle="modal" data-target="#confirmacaoModal"><span class="pull-right badge bg-red"><i class="fa fa-trash"></i> Apagar</span></a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer">
            <div class="col-sm-4" v-show="exibirListagem">
              <button type="button" class="btn btn-primary" v-on:click="novoTurno()">Novo Turno</button>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
    <div class="row center-block" v-if="!exibirListagem">
      <h2 v-if="turnoSelecionado.turno.id !== 0"><a v-on:click="mostrarListagem()" >Listagem </a><small>Editar Turno</small></h2>
      <h2 v-if="turnoSelecionado.turno.id === 0"><a v-on:click="mostrarListagem()">Listagem </a><small>Cadastrar Turno</small></h2>
      <div class="col-md-12" v-show="exibirDetalharTurno">
        <div class="box" v-show="!exibirNovaParada">
          <div class="box-header">
            <h3 class="box-title">Turno</h3>
            <div class="form-group col-sm-12">
              <label for="textoDoTurno" class="col-sm-2 control-label">Nome do Turno</label>
              <div class="col-sm-3">
                <input type="text" class="form-control" id="textoDoTurno" v-model="turnoSelecionado.turno.nometurno">
              </div>
              <label for="inicioDoTurno" class="col-sm-1 control-label">Início</label>
              <div class="col-sm-2">
                <vue-timepicker v-model="turnoSelecionado.horaInicio" format="HH:mm"></vue-timepicker>
              </div>
              <label for="fimDoTurno" class="col-sm-1 control-label">Término</label>
              <div class="col-sm-2">
                <vue-timepicker  v-model="turnoSelecionado.horaFim" format="HH:mm"></vue-timepicker>
              </div>
            </div>
            <div class="form-group col-sm-12">
              <div class="col-sm-1">
                <button type="button" v-on:click="mostrarListagem()" class="btn">Voltar</button>
              </div>
              <div class="col-sm-1">
                <button type="button"  v-on:click="gravarTurno()" class="btn btn-primary">Gravar Turno</button>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
        </div>

        <div class="box" v-if="exibirNovaParada" >
          <div class="box-header">
            <div>
              <p v-if="paradaSelecionada.parada.id === 0">
                <span>
                  <h3 class="box-title">Nova Parada Programada - Turno {{turnoSelecionado.turno.nometurno}}</h3>
                </span>
              </p>
              <p v-else>
                <span>
                  <h3 class="box-title">Editar Parada Programada - Turno {{turnoSelecionado.turno.nometurno}}</h3>
                </span>
              </p>
            </div>
            <div class="form-group col-sm-12">
              <label for="textoDoTurno" class="col-sm-2 control-label">Nome da Parada</label>
              <div class="col-sm-3">
                <input type="text" class="form-control" id="textoDoTurno" v-model="paradaSelecionada.parada.nomeparadaprogramada">
              </div>
              <label for="inicioDoTurno" class="col-sm-1 control-label">Início</label>
              <div class="col-sm-2">
                <vue-timepicker v-model="paradaSelecionada.horaInicio" format="HH:mm"></vue-timepicker>
              </div>
              <label for="fimDoTurno" class="col-sm-1 control-label">Término</label>
              <div class="col-sm-2">
                <vue-timepicker  v-model="paradaSelecionada.horaFim" format="HH:mm"></vue-timepicker>
              </div>
            </div>
            <div class="form-group col-sm-12">
              <div class="col-sm-1">
                <button type="button" v-on:click="voltarTurno()" class="btn">Voltar</button>
              </div>
              <div class="col-sm-1">
                <button type="button"  v-on:click="gravarParadaProgramada()" class="btn btn-primary">Gravar Parada</button>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
        </div>

        <div class="box" v-if="turnoSelecionado.turno.id !== 0" v-show="!exibirNovaParada">
          <div class="box-header">
            <h3 class="box-title">Paradas Programadas</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive">
            <div class="box-body no-padding table-responsive  col-md-12">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <th>Nome da Parada</th>
                    <th>Hora de Início</th>
                    <th>Hora de Término</th>
                    <th class="text-center">Ações</th>
                  </tr>
                  <tr v-for="parada in paradasprogramadas" :key="parada.id">
                    <td>{{parada.nomeparadaprogramada}}</td>
                    <td>{{parada.horainicio}}</td>
                    <td>{{parada.horafim}}</td>
                    <td>
                      <div class="text-center">
                        <a class="btn btn-sm" v-on:click="editarParadaProgramada(parada)"><span class="pull-right badge bg-blue"><i class="fa fa-edit"></i> Editar</span></a> 
                        <a class="btn btn-sm" v-on:click="prepararDeletarParada(parada)" data-toggle="modal" data-target="#confirmacaoModal"><span class="pull-right badge bg-red"><i class="fa fa-trash"></i> Apagar</span></a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.box-body -->
          <div class="box-footer">
            <div class="col-sm-4">
              <button type="button" class="btn btn-primary" v-on:click="novaParadaProgramada()">Nova Parada Programada</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'

export default {
  name: 'Turnos',
  components: { VueTimepicker },
  mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
    }
  },
  computed: {
    turnos () {
      return this.$store.state.Turnos.all
    },
    paradasprogramadas () {
      return this.$store.state.ParadasProgramadas.all
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      tituloModal: '',
      mensagemModal: '',
      showDismissibleAlert: false,
      messageAlert: '',
      turnoParaApagar: {},
      paradaParaApagar: {},
      isTurno: true,
      turnoSelecionado: {
        turno: {
          id: 0,
          nometurno: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: '',
          ss: '00'
        },
        horaFim: {
          HH: '',
          mm: '',
          ss: '00'
        },
        paradasprogramadas: []
      },
      paradaSelecionada: {
        parada: {
          id: 0,
          idturno: 0,
          nomeparadaprogramada: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: '',
          ss: '00'
        },
        horaFim: {
          HH: '',
          mm: '',
          ss: '00'
        }
      },
      exibirDetalharTurno: false,
      exibirNovaParada: false,
      errors: [],
      nomemaquinaTemporario: '',
      exibirListagem: true
    }
  },
  methods: {
    buscarHoraMinuto: function(horaCompleta, isHora) {
      let MinutosIncompletos = horaCompleta.substring(horaCompleta.search(':') + 1, horaCompleta.length)
      if (isHora) {
        return horaCompleta.substring(0, horaCompleta.search(':'))
      } else {
        return MinutosIncompletos.substring(0, MinutosIncompletos.search(':'))
      }
    },
    novoTurno: function() {
      if (window.localStorage.getItem('token')) {
        this.limparTurnoSelecionado()
        this.exibirListagem = false
        this.exibirDetalharTurno = true
      } else {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor efetuar o login para gravar um novo turno'
      }
    },
    limparTurnoSelecionado: function() {
      this.turnoSelecionado = {
        turno: {
          id: 0,
          nometurno: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: ''
        },
        horaFim: {
          HH: '',
          mm: ''
        }
      }
    },
    voltarTurno: function() {
      this.$store.dispatch('listTurnos')
      this.exibirNovaParada = false
      this.limparParadaSelecionada()
    },
    prepararDeletarTurno: function(turnoSelecionado) {
      this.isTurno = true
      this.turnoParaApagar = turnoSelecionado
      this.tituloModal = 'Confirmação de Exclusão de Turno'
      this.mensagemModal = 'Tem certeza que deseja excluir o turno? Essa operação não poderá ser desfeita!'
    },
    deletarTurno: function(turnoSelecionado) {
      this.$store.dispatch('deleteTurno', turnoSelecionado.id)
      .then(response => {
        this.$store.dispatch('listTurnos')
      })
      .catch(err => {
        if (err.response.status === 403) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema'
        } else {
          this.showDismissibleAlert = true
          this.messageAlert = 'Falha ao apagar o turno. Favor contatar o administrador do sistema informando a mensagem: ' + err
        }
      })
    },
    selecionarTurno: function(turno) {
      this.exibirListagem = false
      this.exibirDetalharTurno = true
      this.turnoSelecionado.turno = turno
      this.turnoSelecionado.horaInicio.HH = this.buscarHoraMinuto(turno.horainicio, true)
      this.turnoSelecionado.horaInicio.mm = this.buscarHoraMinuto(turno.horainicio, false)
      this.turnoSelecionado.horaFim.HH = this.buscarHoraMinuto(turno.horafim, true)
      this.turnoSelecionado.horaFim.mm = this.buscarHoraMinuto(turno.horafim, false)
      this.$store.dispatch('listParadasProgramadas', this.turnoSelecionado.turno.id)
    },
    gravarTurno: function() {
      if (this.turnoSelecionado.turno.id === 0) {
        this.$store.dispatch('createTurno', {
          nometurno: this.turnoSelecionado.turno.nometurno,
          horainicio: this.turnoSelecionado.horaInicio.HH + ':' + this.turnoSelecionado.horaInicio.mm,
          horafim: this.turnoSelecionado.horaFim.HH + ':' + this.turnoSelecionado.horaFim.mm
        })
        .then(response => {
          this.turnoSelecionado.turno = response.data
          this.$store.dispatch('listTurnos')
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao gravar um novo turno. Favor contatar o administrador do sistema informando a mensagem: ' + err
          }
        })
      } else {
        // Inicio de POG por causa do BUG de se não selecionar dá erro
        let horaInicioAlterada = ''
        let horaFimAlterada = ''
        if (this.turnoSelecionado.horaInicio.mm === 'NaN') {
          horaInicioAlterada = this.turnoSelecionado.turno.horainicio
        } else {
          horaInicioAlterada = this.turnoSelecionado.horaInicio.HH + ':' + this.turnoSelecionado.horaInicio.mm + ':00'
        }
        if (this.turnoSelecionado.horaFim.mm === 'NaN') {
          horaFimAlterada = this.turnoSelecionado.turno.horafim
        } else {
          horaFimAlterada = this.turnoSelecionado.horaFim.HH + ':' + this.turnoSelecionado.horaFim.mm + ':00'
        }
        // Fim do POG
        this.$store.dispatch('updateTurno', {
          id: this.turnoSelecionado.turno.id,
          turno: {
            nometurno: this.turnoSelecionado.turno.nometurno,
            horainicio: horaInicioAlterada,
            horafim: horaFimAlterada
          }
        })
        .then(response => {
          this.$store.dispatch('listTurnos')
          this.mostrarListagem()
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao alterar o turno. Favor contatar o administrador do sistema informando a mensagem: ' + err
          }
        })
      }
    },
    editarParadaProgramada: function(parada) {
      this.paradaSelecionada.parada = parada
      this.paradaSelecionada.horaInicio.HH = this.buscarHoraMinuto(parada.horainicio, true)
      this.paradaSelecionada.horaInicio.mm = this.buscarHoraMinuto(parada.horainicio, false)
      this.paradaSelecionada.horaFim.HH = this.buscarHoraMinuto(parada.horafim, true)
      this.paradaSelecionada.horaFim.mm = this.buscarHoraMinuto(parada.horafim, false)
      this.exibirNovaParada = true
    },
    novaParadaProgramada: function() {
      this.exibirNovaParada = true
    },
    gravarParadaProgramada: function() {
      if (this.paradaSelecionada.parada.id === 0) {
        this.$store.dispatch('createParadaProgramada', {
          idturno: this.turnoSelecionado.turno.id,
          nomeparadaprogramada: this.paradaSelecionada.parada.nomeparadaprogramada,
          horainicio: this.paradaSelecionada.horaInicio.HH + ':' + this.paradaSelecionada.horaInicio.mm,
          horafim: this.paradaSelecionada.horaFim.HH + ':' + this.paradaSelecionada.horaFim.mm
        })
        .then(response => {
          this.paradaSelecionada.parada = response.data
          this.$store.dispatch('listParadasProgramadas', this.turnoSelecionado.turno.id)
          this.limparParadaSelecionada()
          this.exibirNovaParada = false
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao gravar a Parada Programada. Favor contatar o administrador do sistema informando a mensagem: ' + err
          }
        })
      } else {
        // Inicio de POG por causa do BUG de se não selecionar dá erro
        let horaInicioAlterada = ''
        let horaFimAlterada = ''
        if (this.paradaSelecionada.horaInicio.mm === 'NaN') {
          horaInicioAlterada = this.paradaSelecionada.parada.horainicio
        } else {
          horaInicioAlterada = this.paradaSelecionada.horaInicio.HH + ':' + this.paradaSelecionada.horaInicio.mm + ':00'
        }
        if (this.paradaSelecionada.horaFim.mm === 'NaN') {
          horaFimAlterada = this.paradaSelecionada.parada.horafim
        } else {
          horaFimAlterada = this.paradaSelecionada.horaFim.HH + ':' + this.paradaSelecionada.horaFim.mm + ':00'
        }
        // Fim do POG
        this.$store.dispatch('updateParadaProgramada', {
          id: this.paradaSelecionada.parada.id,
          paradaprogramada: {
            idturno: this.paradaSelecionada.parada.idturno,
            nomeparadaprogramada: this.paradaSelecionada.parada.nomeparadaprogramada,
            horainicio: horaInicioAlterada,
            horafim: horaFimAlterada
          }
        })
        .then(response => {
          this.$store.dispatch('listParadasProgramadas', this.turnoSelecionado.turno.id)
          this.limparParadaSelecionada()
          this.exibirNovaParada = false
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showDismissibleAlert = true
            this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema'
          } else {
            this.showDismissibleAlert = true
            this.messageAlert = 'Falha ao alterar a Parada Programada. Favor contatar o administrador do sistema informando a mensagem: ' + err
          }
        })
      }
    },
    prepararDeletarParada: function(paradaSelecionada) {
      this.isTurno = false
      this.paradaParaApagar = paradaSelecionada
      this.tituloModal = 'Confirmação de Exclusão de Parada Programada'
      this.mensagemModal = 'Tem certeza que deseja excluir a Parada Programada? Essa operação não poderá ser desfeita!'
    },
    deletarParada: function(paradaSelecionada) {
      this.$store.dispatch('deleteParadaProgramada', paradaSelecionada.id)
      .then(response => {
        this.$store.dispatch('listParadasProgramadas', this.turnoSelecionado.turno.id)
      })
      .catch(err => {
        if (err.response.status === 403) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Você não possui privilégios para executar essa ação. Favor contactar o responsável pelo sistema'
        } else {
          this.showDismissibleAlert = true
          this.messageAlert = 'Falha ao apagar a Parada Programada. Favor contatar o administrador do sistema informando a mensagem: ' + err
        }
      })
    },
    limparParadaSelecionada: function() {
      this.paradaSelecionada = {
        parada: {
          id: 0,
          idturno: 0,
          nomeparadaprogramada: '',
          horainicio: '',
          horafim: '',
          created_at: '',
          updated_at: ''
        },
        horaInicio: {
          HH: '',
          mm: ''
        },
        horaFim: {
          HH: '',
          mm: ''
        }
      }
    },
    mostrarListagem: function() {
      this.$store.dispatch('listTurnos')
      this.$store.dispatch('clearListParadasProgramadas')
      this.exibirListagem = true
      this.exibirDetalharTurno = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Turnos.vue?561c1504